/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { getCustomer } from "../../../shared/services/services";
import { CustomerData, CustomerTableData } from "src/shared/types";

const useCustomer = (reFresh: boolean, filter?: boolean, page?: number, row?: number, searchTerm?: string, sortField?: string, order?: string) => {
  const [customer, setCustomer] = useState<CustomerTableData>();
  const [onlyCustomer, setOnlyCustomer] = useState<CustomerData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const timerRef = useRef<NodeJS.Timeout | null>(null);


  const fetchCustomers = () => {
    setLoading(true);
    getCustomer(filter, page, row, searchTerm, sortField, order)
      .then((res) => {
        const result = res?.data;
        setCustomer(result);
        setOnlyCustomer(result?.customer_details || []);
      })
      .catch((err) => {
        console.error("Error fetching customers:", err);
      })
      .finally(() => setLoading(false));
  };


  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      fetchCustomers();
    }, searchTerm ? 700 : 1000);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [reFresh, filter, page, row, searchTerm, sortField, order]);

  return { customer, loading, onlyCustomer };
};

export default useCustomer;
